module.exports = __webpack_public_path__ + "c48f654c8e5628d2ab0fa73d4dc58e41.svg";